import { configTranslations } from '../app/src/config/translations/configTranslations.js';
import { onChangeLanguage } from '../shared/DOM/onChangeLanguage.js';
import { removePageLoader } from '../shared/DOM/removePageLoader.js';
import { RESULT_REDIRECT_DIRECTLY } from './src/form/constant.js';
import { login } from './src/login.js';

start();

async function start() {
  await configTranslations();
  onChangeLanguage();
  const result = await login();

  if (RESULT_REDIRECT_DIRECTLY !== result) {
    removePageLoader();
  }
}
